<template>
  <div>
    <el-form class="selectlesson">
      <el-form-item label="选择网校">
        <el-select
          clearable
          v-model="model.maID"
          @change="getNewsBanner"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          clearable
          v-model="model.chID"
          @change="getCourse"
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item clearable label="二级分类">
        <el-select
          clearable
          v-model="model.coID"
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            clearable
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          clearable
          v-model="model.clID"
          @change="getNewsBanner"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <template v-show="tableData">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          prop="createAt"
          label="日期"
          :formatter="formatDate"
          width="150"
        >
        </el-table-column>
        <el-table-column prop="bannerName" label="banner名称">
        </el-table-column>
        <el-table-column prop="bannerDesc" label="banner描述">
        </el-table-column>
        <el-table-column prop="bannerUrl" label="banner跳转链接">
        </el-table-column>
        <el-table-column prop="bannerImg" width="480" label="图片">
          <template slot-scope="scope">
            <el-image
              style="width: 100%; height: 250px"
              :src="scope.row.bannerImg"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              style="margin: 3px 3px 3px 3px"
              @click="delNewsBanner(scope.row)"
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              >删除</el-button
            >
            <el-button
              style="margin: 3px 3px 3px 3px"
              @click="$router.push(`/newsbanner/edit/${scope.row.id}`)"
              type="primary"
              size="small"
              icon="el-icon-edit"
              plain
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
    <el-skeleton :loading="loading" :rows="10" animated />
    <!--  grade分类分页 -->
    <div class="grade-page">
      <el-pagination
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        @prev-click="contentpre"
        @next-click="contentnext"
        background
        layout="prev, pager, next,total,jumper,sizes"
        :total="resultlength"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { timerfilter } from "../util/timerfilter";
//import moment from 'moment'

export default {
  data() {
    return {
      major: [],
      channel: [],
      course: [],
      shclass: [],
      tableData: [],
      model: [],
      loading: true,
      resultlength: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      viewcontent: "",
      //isShow: true,
    };
  },
  methods: {
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel(item) {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }

      //this.getcontent(item);
    },
    async getCourse(item) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID: item },
        });
        this.course = getcourse.data;
        this.getNewsBanner(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(item) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID: item },
        });
        this.shclass = getclass.data;
        this.getNewsBanner(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getNewsBanner() {
      try {
        const result = await this.$http.get("/news/banner/list", {
          params: {
            maID: this.model.maID,
            chID: this.model.chID,
            coID: this.model.coID,
            clID: this.model.clID,
            page: this.currentPage,
            size: this.pageSize,
          },
        });

        this.tableData = result.data[0].result.map((item) => {
          return {
            bannerID: item.bannerID,
            bannerDesc: item.bannerDesc,
            bannerImg: "/" + item.bannerImg,
            bannerName: item.bannerName,
            id: item._id,
          };
        });
        this.resultlength = result.data[0].resultLength[0].totalCount;
      } catch (error) {
        console.log(error);
      }
    },
    /*    async conView(row) {
      this.dialogVisible = true;
      const result = await this.$http.get(
        "/content/viewcontent?_id=" + `${row._id}`
      );
      this.viewcontent = result.data;
    }, */
    delNewsBanner(row) {
      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring",
        center: true,
      })
        .then(async () => {
          const res = await this.$http.get(
            "/news/banner/delete?_id=" + `${row._id}`
          );

          if (res.status === 203) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getNewsBanner();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
    //lesson分类分页
    async contentpre() {
      this.currentPage--;

      //this.getTertiary(this.pageSize);
      //console.log("上一页");
    },
    async contentnext() {
      this.currentPage++;
      // this.getTertiary(this.pageSize);
      //console.log(this.pageSize);
    },
    async changeSize(size) {
      this.pageSize = size;
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getNewsBanner(this.currentPage);
      //console.log(this.currentPage);
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.getNewsBanner();
  },
};
</script>
